import { LocalStorageContainer } from '../../../shared/src/helpers/LocalStorageContainer';
import { SESSION_ID } from './SessionID';

export class PersistentHistory {
  private static _container = new LocalStorageContainer<PersistentHistory.LocalStorage.Model>(
    '__HISTORY__'
  );

  static HISTORY_LENGTH = 4;

  static load = (): PersistentHistory.LocalStorage.Model => {
    return PersistentHistory._container.get()?.toReversed() ?? [];
  };

  static update = (items: PersistentHistory.LocalStorage.Item[]) => {
    try {
      const newList = {
        id: SESSION_ID,
        date: +new Date(),
        items: items.map(({ name, sum }) => ({ name: name.trim(), sum: sum })),
      };

      const history = PersistentHistory.load();

      const lists = history.map(savedList => (savedList.id === SESSION_ID ? newList : savedList));

      if (!lists.find(list => list.id === SESSION_ID)) {
        lists.push(newList);
      }

      PersistentHistory._container.set(
        lists.length > PersistentHistory.HISTORY_LENGTH
          ? lists.slice(lists.length - PersistentHistory.HISTORY_LENGTH)
          : lists
      );
    } catch (e) {}
  };

  static delete = (id: number) => {
    const history = PersistentHistory.load();

    PersistentHistory._container.set(history.filter(list => list.id !== id));
  };
}

export namespace PersistentHistory {
  export namespace LocalStorage {
    export type Item = {
      name: string;
      sum: number;
    };

    export type List = {
      id: number;
      date: number;
      items: Item[];
    };

    export type Model = PersistentHistory.LocalStorage.List[];
  }
}
